/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { AMFileDetailContainer } from './container';
import { useNavigate } from 'react-router-dom';
import appRoutes from '../../AppNavigator/services/config/routes.config.json';

export const AMFileDetailPage = ({
  navigation,
}: {
  navigation: any;
}) => {
  const navigate = useNavigate();
  const routes = appRoutes?.routes;
  // search: `?orgid=${data?.appCardId}`,
  return (
    <AMFileDetailContainer
      onViewDetailClick={(data: any) => {
        // navigate(routes?.TransactionsOverView?.path, {
        //   state: { params: data },
        // })
      }}
    />
  );
};
